import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CustomerService } from '../shared/services/customer.service';
import { Customer } from '../shared/models/customer.model';
import { FaqService } from '../shared/services/faq.service';
import { FaQModel } from '../shared/models/faq.model';
import { CommunicationService } from '../shared/services/communication.service';
import { Router } from '@angular/router';
//import { EventEmitter } from 'protractor';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css']
})
export class SideMenuComponent implements OnInit {
  searchKey : string;
  searchFaQKey : string;
  thisData : Customer [];
  thisDataFaQ : FaQModel [];

  @Output() clickEvent = new EventEmitter();

  constructor(
    private router : Router,
    private cservice : CustomerService, 
    private fservice : FaqService,
    private commservice : CommunicationService) { }

  ngOnInit() {
  
  }
// Search For Customer
  onSearch(){
    if(this.searchKey == null || this.searchKey.length < 3)
    {
      alert("Please input more than 3 characters.");
      return;
    }
    console.log("onSearch" + ":" + this.searchKey);
    
    this.cservice.findCustomerList(this.searchKey).subscribe(
      res=>{
        this.thisData = res as Customer[];
        console.log(this.thisData);
      },
      err=>{}
    );
  }

  onSearchClear()
  {
    console.log("onSearchClear");
    this.searchKey = "";
    this.thisData = null;
    
  }

  onSelectCustomer(item)
  {
    this.router.navigate(['/techsupport']);
    this.router.events.subscribe(value => {
     // console.log('current route: ', this.router.url.toString());
      if(this.router.url.endsWith("techsupport"))
      {
        this.commservice.sendMessage(item.phoneno);
      }
  });
    console.log("onSelectCustomer :" + item.phoneno);
    //this.clickEvent.emit(item.phoneno);
    this.commservice.sendMessage(item.phoneno);
  }
// Search For KB
  onSearchFaQ(){

    if(this.searchFaQKey == null || this.searchFaQKey.length < 3)
    {
      alert("Please input more than 3 characters.");
      return;
    }
    console.log("onSearchKB" + ":" + this.searchFaQKey);
    
    this.fservice.findData(this.searchFaQKey).subscribe(
      res=>{
        this.thisDataFaQ = res as FaQModel[];
        console.log(this.thisDataFaQ);
      },
      err=>{}
    );
  }

  onSearchClearFaQ()
  {
    console.log("onSearchClearFaQ");
    this.searchFaQKey = "";
    this.thisDataFaQ = null;
    
  }

  onSelectFaQ(item)
  {
    var url = this.router.serializeUrl(
      this.router.createUrlTree(['/faqpopup'])
    );

    //var strWindowFeatures = "menubar=no,location=no,resizable=no,scrollbars=no,status=yes,width=400,height=350";
    var strWindowFeatures = "width=400,height=350";

    console.log("onSelectFaQ :" +  url + ":"+ item.faqId);
    window.open(url + "?id=" + item.faqId, '_blank', strWindowFeatures);
  }
}
